// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q17t","question":"styles_question__2RHlQ","description":"styles_description__3Ktvz"};